/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InstallDbObjectTypeEnum } from './installDbObjectTypeEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { AWSRegionsEnum } from './aWSRegionsEnum';


export interface InstallDbClosureRequest { 
    /**
     * Email of the user
     */
    email?: string;
    /**
     * Any additional comments or error message about the action and/or status
     */
    message?: string;
    object_type: InstallDbObjectTypeEnum;
    /**
     * Org Id of user requesting \"action\"
     */
    orgId: string;
    region: AWSRegionsEnum;
    serviceType: ServiceTypeEnum;
}
export namespace InstallDbClosureRequest {
}


